const userFlags = {
  account_manager_bubble: {
    type: Date,
  },
  // cookie_warning: {
  //   type: Date
  // },
  matches_intro: {
    type: Date,
  },
  leads_intro: {
    type: Date,
  },
  calendar_intro_step: {
    type: Number,
    default: 0,
  },
  calendar_intro_count: {
    type: Number,
    default: 0,
  },
};
module.exports = userFlags;
